// eslint-disable-next-line
import React from 'react';
import ToggleDirections from '../../../../../common/ToggleDirections';
import AttendanceStep from '../AttendanceStep';

function StudentRosterDirectionsSAT({ showDirectionInfo = false }) {
  return (
    <ToggleDirections showDirectionInfo={showDirectionInfo}>
      <div className='row p-3' role='region' aria-label='directions'>
        <div className='col-md-4 px-4 cb-margin-sm-down-bottom-32'>
          <AttendanceStep
            step={1}
            title='Ask students to check in.'
            descr={
              <p>
                Student names will display in the <strong>Entered Room Code</strong> list when they enter the room code.
              </p>
            }
            tooltip={{
              linkName: 'What if some students are missing from the "Assigned" list?',
              descr: (
                <>
                  If students weren’t assigned to your room before test day, they’ll be added to the{' '}
                  <strong>Entered Room Code</strong> list when they enter the room code.
                </>
              ),
            }}
          />
        </div>
        <div className='col-md-4 px-4 cb-margin-sm-down-bottom-32'>
          <AttendanceStep
            step={2}
            title='Mark students present.'
            descr={
              <p>
                Before you mark a student present, make sure you see them in your room. If you see them but they’re not
                shown in the <strong>Entered Room Code</strong> list, prompt them to enter the room code.
              </p>
            }
            tooltip={{
              linkName: <>What if students don’t see today’s test listed in Bluebook&trade;?</>,
              descr: <>Tell them to sign out and sign in again using the sign-in ticket you gave them.</>,
            }}
          />
        </div>
        <div className='col-md-4 px-4'>
          <AttendanceStep
            step={3}
            title='Check student progress.'
            descr={
              <p>
                Students are listed as <strong>Ready to Test</strong> when they complete check-in. If everyone you
                marked present is ready to test, click <strong>Next Step</strong> and read the script.
              </p>
            }
            tooltip={{
              linkName: 'What if some students are behind?',
              descr: (
                <>
                  Remind students to complete check-in. If they can’t do it quickly, continue to the next step so they
                  don’t delay others. You can help them get started later.
                  <br />
                  <br />
                  NOTE: Students can’t start testing until you mark them present.
                </>
              ),
            }}
          />
        </div>
      </div>
    </ToggleDirections>
  );
}

export default StudentRosterDirectionsSAT;
